export const LATEST_UPDATES_API_URL =
  'https://www.paperlessparts.com/api/latest-updates/';

export const LATEST_PRODUCT_UPDATES_COUNT = 3;

export const PRODUCT_UPDATES_UTM_PARAMS =
  'utm_source=platform&utm_medium=paperless-parts-platform&utm_campaign=in-app-product-blog';

export const PRODUCT_UPDATES_LIST_URL = `https://www.paperlessparts.com/product-updates/?${PRODUCT_UPDATES_UTM_PARAMS}`;

export const LATEST_PRODUCT_UPDATES_STALE_TIME_MS = 5 * 60 * 1000;
